import React, { Component } from 'react'
import cn from 'classnames'
import uuidv4 from 'uuid/v4'
import PropTypes from 'prop-types'

import { normalizePhoneBeforeInsert } from 'helpers/parsePhone'
import { ISO_CODE, USA_ISO } from 'app/constants/phoneCountryCodes'
import CountryCodeItem from 'app/components/CountryCodeItem'

import './styles.scss'
export const bc = 'country-code-select'

class CountryCodeSelect extends Component {
  componentDidMount() {
    document.addEventListener('click', this.detectClickOutsideTheElement)
    document.addEventListener('touchstart', this.detectClickOutsideTheElement)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.detectClickOutsideTheElement)
    document.removeEventListener('touchstart', this.detectClickOutsideTheElement)
  }

  state = {
    isOpenDropDown: false,
    uuidv4: uuidv4(),
  }

  detectClickOutsideTheElement = e => {
    const currentEl = document.getElementById(this.state.uuidv4)
    if (currentEl && currentEl.contains(e.target)) {
      this.toggleDropDown(true)
    } else {
      this.toggleDropDown(false)
    }
  }

  toggleDropDown = bool => this.setState({ isOpenDropDown: bool })

  selectOption = value => {
    const { meta: { form }, input: { name }, handleOnChange, phoneFieldName } = this.props
    handleOnChange(form, name, value)
    handleOnChange(form, phoneFieldName, normalizePhoneBeforeInsert(value, this.props.selectedValuePhone))
    this.toggleDropDown(false)
  }

  render() {
    const { isOpenDropDown, uuidv4 } = this.state
    const { selectedValue = USA_ISO, className, classNamePhoneComponentItem, options } = this.props

    const selectedOption = options.find(el => el.value === selectedValue)
    const filteredOptions = options.filter(el => el.value !== selectedValue)
    return (
      <div className={cn(`${bc}__wrapper`, { [className]: className })} id={uuidv4}>
        <CountryCodeItem
          getValue={option => ISO_CODE[option.value]}
          option={selectedOption}
          className={cn(`${bc}__item-select`, { [classNamePhoneComponentItem]: classNamePhoneComponentItem })}
        />
        {isOpenDropDown && (
          <div className={`${bc}__dropdown`}>
            {filteredOptions.map(el => (
              <CountryCodeItem
                key={el.value}
                option={el}
                handleClick={() => this.selectOption(el.value)}
                getValue={option => ISO_CODE[option.value]}
              />
            ))}
          </div>
        )}
      </div>
    )
  }
}

CountryCodeSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    })
  ).isRequired,
}

export default CountryCodeSelect
